import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_ee61cb44 from 'nuxt_plugin_workbox_ee61cb44' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6f8f2371 from 'nuxt_plugin_metaplugin_6f8f2371' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_step_9260ba80 from 'nuxt_plugin_step_9260ba80' // Source: ../plugins/step (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_lazyload_0d09004e from 'nuxt_plugin_lazyload_0d09004e' // Source: ../plugins/lazyload (mode: 'all')
import nuxt_plugin_cubeui_c0220a90 from 'nuxt_plugin_cubeui_c0220a90' // Source: ../plugins/cube-ui (mode: 'all')
import nuxt_plugin_fonttransform_674c833c from 'nuxt_plugin_fonttransform_674c833c' // Source: ../plugins/font-transform (mode: 'all')
import nuxt_plugin_track_2331d3d7 from 'nuxt_plugin_track_2331d3d7' // Source: ../plugins/track (mode: 'client')
import nuxt_plugin_vuedirective_4544c958 from 'nuxt_plugin_vuedirective_4544c958' // Source: ../plugins/vue-directive (mode: 'client')
import nuxt_plugin_vueplugins_bf71f036 from 'nuxt_plugin_vueplugins_bf71f036' // Source: ../plugins/vue-plugins (mode: 'client')
import nuxt_plugin_dulang_27ea5cf3 from 'nuxt_plugin_dulang_27ea5cf3' // Source: ../plugins/dulang (mode: 'all')
import nuxt_plugin_toast_233078b3 from 'nuxt_plugin_toast_233078b3' // Source: ../plugins/toast (mode: 'client')
import nuxt_plugin_messagebox_7ff46091 from 'nuxt_plugin_messagebox_7ff46091' // Source: ../plugins/message-box (mode: 'client')
import nuxt_plugin_index_256d6058 from 'nuxt_plugin_index_256d6058' // Source: ../plugins/vconsole/index (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"POIZON","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"},{"name":"apple-mobile-web-app-title","content":"POIZON"},{"name":"wap-font-scale","content":"no"},{"name":"msapplication-tap-highlight","content":"no"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"full-screen","content":"yes"},{"name":"screen-orientation","content":"portrait"},{"name":"x5-fullscreen","content":"true"},{"name":"x5-orientation","content":"portrait"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"format-detection","content":"telephone=no, email=no, address=no"},{"name":"theme-color","content":"#000000"},{"name":"share","content":"POIZON"},{"name":"keywords","content":"POIZON"},{"hid":"description","name":"description","content":"POIZON"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"http-equiv":"x-dns-prefetch-control","content":"on"},{"property":"og:type","content":"website"},{"property":"og:title","content":"POIZON"},{"property":"og:description","content":"POIZON"}],"script":[{"crossorigin":"anonymous","defer":true,"src":"https:\u002F\u002Fcdn.poizonapp.com\u002Fotel-trace\u002Fotel.min.js"}],"link":[{"hid":"icon","rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fcdn.poizon.com\u002Fnode-common\u002F1ef8282aa5ac7c001c7ea8a8cd29c732.png"},{"hid":"shortcut icon","rel":"shortcut icon","href":"https:\u002F\u002Fcdn.poizon.com\u002Fnode-common\u002F1ef8282aa5ac7c001c7ea8a8cd29c732.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"https:\u002F\u002Fcdn.poizon.com\u002Fnode-common\u002F1ef8282aa5ac7c001c7ea8a8cd29c732.png"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_ee61cb44 === 'function') {
    await nuxt_plugin_workbox_ee61cb44(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6f8f2371 === 'function') {
    await nuxt_plugin_metaplugin_6f8f2371(app.context, inject)
  }

  if (typeof nuxt_plugin_step_9260ba80 === 'function') {
    await nuxt_plugin_step_9260ba80(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyload_0d09004e === 'function') {
    await nuxt_plugin_lazyload_0d09004e(app.context, inject)
  }

  if (typeof nuxt_plugin_cubeui_c0220a90 === 'function') {
    await nuxt_plugin_cubeui_c0220a90(app.context, inject)
  }

  if (typeof nuxt_plugin_fonttransform_674c833c === 'function') {
    await nuxt_plugin_fonttransform_674c833c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_track_2331d3d7 === 'function') {
    await nuxt_plugin_track_2331d3d7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedirective_4544c958 === 'function') {
    await nuxt_plugin_vuedirective_4544c958(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplugins_bf71f036 === 'function') {
    await nuxt_plugin_vueplugins_bf71f036(app.context, inject)
  }

  if (typeof nuxt_plugin_dulang_27ea5cf3 === 'function') {
    await nuxt_plugin_dulang_27ea5cf3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_233078b3 === 'function') {
    await nuxt_plugin_toast_233078b3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_messagebox_7ff46091 === 'function') {
    await nuxt_plugin_messagebox_7ff46091(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_256d6058 === 'function') {
    await nuxt_plugin_index_256d6058(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
